import { type FC } from 'react';
import {
  SignIn
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconSignInProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconSignIn: FC<UiIconSignInProps> = (props) => {
  return (
    <UiIcon
      IconComponent={SignIn}
      {...props}
    />
  );
};
